module.exports = __webpack_public_path__ + "img/d.34c5d43c.jpg";